import React from 'react';

const PhoneIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.19426 3.6276C5.27861 4.80732 5.48949 5.96052 5.82689 7.0607L4.13987 8.65133C3.56347 7.0607 3.19794 5.37729 3.07142 3.6276H5.19426ZM19.056 19.5604C20.251 19.8785 21.4741 20.0773 22.7112 20.1568V22.1319C20.8555 22.0126 19.0701 21.6679 17.369 21.1377L19.056 19.5604ZM6.54388 0.976562H1.62338C0.850164 0.976562 0.217529 1.57305 0.217529 2.30208C0.217529 14.7487 10.9161 24.8359 24.1171 24.8359C24.8903 24.8359 25.5229 24.2395 25.5229 23.5104V18.8843C25.5229 18.1553 24.8903 17.5588 24.1171 17.5588C22.3738 17.5588 20.6727 17.2937 19.0982 16.8033C18.9576 16.7503 18.8029 16.737 18.6624 16.737C18.2968 16.737 17.9454 16.8696 17.6642 17.1214L14.5713 20.0375C10.5927 18.1155 7.33116 15.0536 5.30673 11.3024L8.39961 8.38622C8.79325 8.01508 8.90572 7.49812 8.75107 7.03419C8.2309 5.54961 7.94973 3.95898 7.94973 2.30208C7.94973 1.57305 7.3171 0.976562 6.54388 0.976562Z"
                fill="#4A4A4A"
            />
        </svg>
    );
};

export default PhoneIcon;
